import Vue from 'vue';
import VueFlashMessage from '@smartweb/vue-flash-message';
Vue.use(VueFlashMessage, {
  time: 5000,
  strategy: "multiple"
});
export default (function (context, inject) {
  inject("flashMessage", Vue.prototype.flashMessage);
});